import React from 'react'

import { mockCopyBundle } from './fixtures'
import type { CopyContextValue, SupportedLocales } from './types'

type CopyContextProps = {
  children: React.ReactNode
} & CopyContextValue

export const CopyContext = React.createContext<CopyContextValue>({
  appName: '',
  locale: 'en',
  copy: {},
})

export function CopyProvider({
  children,
  appName,
  locale,
  copy,
}: CopyContextProps) {
  return (
    <CopyContext.Provider value={{ appName, locale, copy }}>
      {children}
    </CopyContext.Provider>
  )
}

export function MockCopyProvider({
  children = <h1>The app</h1>,
  locale = 'en',
  copy = mockCopyBundle,
}: Omit<CopyContextProps, 'appName'>) {
  return (
    <CopyProvider appName="app.mock-web-app" locale={locale} copy={copy}>
      {children}
    </CopyProvider>
  )
}

export function createMockCopyProvider(
  locale: SupportedLocales,
  copy: CopyContextProps['copy'],
) {
  return function Wrapper({ children }: { children: JSX.Element }) {
    return (
      <MockCopyProvider locale={locale} copy={copy}>
        {children}
      </MockCopyProvider>
    )
  }
}
